import { render, staticRenderFns } from "./GrossingSideBar.vue?vue&type=template&id=6579eb7a&"
import script from "./GrossingSideBar.vue?vue&type=script&lang=js&"
export * from "./GrossingSideBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports